var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportarSucess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11.2 ExportarExc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FACTURACION",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Clientes",
    transform: "translate(-1043.000000, -117.000000)",
    stroke: "#14B8A6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(951.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(93.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.2-ExportarExc",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.51984127,
    y1: 0,
    x2: 4.51984127,
    y2: 8.5,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 11.7380952,
    x2: 8.5,
    y2: 11.7380952,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "1.61904762 5.66666667 4.45238095 8.5 7.28571429 5.66666667"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportarSucess);
export default __webpack_public_path__ + "static/media/ExportarSucess.3d60b04c264ba4a256dd816ea870d3a3.svg";
export { ForwardRef as ReactComponent };